import { EditIcon } from '@chakra-ui/icons'
import { Badge, BadgeProps, Button, ButtonProps, IconButton } from '@chakra-ui/react'
import { colors, Status, StatusType } from '@hb/shared'
import * as React from 'react'
import { useStatusButton } from './hooks'

export interface StatusButtonProps extends Omit<ButtonProps, 'type'> {
  type: StatusType
  status: Status
  text?: string
  onClick?: () => void
}

export const StatusButton: React.FC<StatusButtonProps> = ({
  type,
  status,
  onClick,
  text,
  ...props
}) => {
  const { buttonText } = useStatusButton(type, status)

  return status === 'complete' ? (
    <IconButton
      float="right"
      aria-label="edit"
      icon={<EditIcon width={3.5} height={3.5} />}
      color={colors.green.hex}
      px={2}
      onClick={onClick}
      variant={onClick ? 'ghost' : 'unstyled'}
      sx={{ cursor: onClick ? 'pointer' : 'default' }}
      size="sm"
      borderRadius="full"
      {...props}
    />
  ) : (
    <Button
      onClick={onClick}
      fontWeight={500}
      // float="right"
      px={2}
      color={status === 'info' ? '#777' : colors.green.hex}
      sx={{ cursor: onClick ? 'pointer' : 'default' }}
      variant={onClick ? 'ghost' : 'unstyled'}
      minH="0"
      // borderColor={colors.green.hex}
      size="xs"
      {...props}>
      {text ?? buttonText}
    </Button>
    // <Badge
    //   fontWeight={500}
    //   py='0.1rem'
    //   onClick={onClick}
    //   style={{
    //     pointerEvents: onClick ? 'auto' : 'none',
    //     cursor: onClick ? 'pointer' : 'default',
    //   }}
    //   variant='outline'
    //   // background={buttonColor}
    //   // color={buttonBackground}
    //   colorScheme={colorScheme}
    //   {...badgeProps}
    // >
    //   {text || buttonText}
    // </Badge>
  )
}

export const StatusBadge: React.FC<
  {
    type: StatusType
    status: Status
  } & BadgeProps
> = ({ type, status, ...props }) => {
  const { buttonText, buttonColor } = useStatusButton(type, status)
  return (
    <Badge bg={`${buttonColor}10`} {...props}>
      {buttonText}
    </Badge>
  )
}
